/*
 * @Author: your name
 * @Date: 2021-07-05 10:40:24
 * @LastEditTime: 2021-07-19 11:21:48
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \platform_wechat\src\store.js
 */
import Vue from 'vue'
import Vuex from 'vuex'
// import baseUrl from './config'
Vue.use(Vuex)
function isIos(){
    const u = navigator.userAgent;
    return u.indexOf("iPhone") > -1 || u.indexOf("Mac OS") > -1;
   }
export default new Vuex.Store({
    state: {
        isLoading: false,
        openid: localStorage.getItem('openid') ? localStorage.getItem('openid') : '',
        time: "",
        time1: "",
        toPath: '',
        imgUrl: 'https://www.esw235.com/',
        coord: '',
        wxSignUrl:'',
        baseUrl:'https://dev.service.eswhyf.cn'
    },
    mutations: {
        updateLoadingStatus(state, isLoading) {
            state.isLoading = isLoading;
        },
        timer(state, value) {
            state.time = value
        },
        timer1(state, value) {
            state.time1 = value
        },
        wxSignUrl(state, wxSignUrl) {
            if (isIos() && state.wxSignUrl !== '') {
                return;
               }
               state.wxSignUrl = wxSignUrl;

        },
        openid(state, value) {
            state.openid = value
        },
        toPath(state, value) {
            state.toPath = value
        },
        location(state, value) {
            state.coord = value
        }
    },
    actions: {

    }
})
